import { ProductPreviewCardBase } from '@/entities/product/ui/ProductPreviewCardBase';

export { ProductPreviewCardBase };
